import { react, useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import TokenService from '../../services/TokenService';

export default function ViewZipcodeBoundry(props) {
    const handleClose = () => {
        props.Close('');
    };
   
    const [isLoading, setIsLoading] = useState(true);
    const [boundryData, setBoundryData] = useState(true);
    useEffect(() => {
        loadBoundryData(); // only called once
    }, []);

    function loadBoundryData() {
        let postData = {
            zipCode: props.Zipcode
        }
        TokenService.post(postData, 'SelectByZipcode')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    setBoundryData(response.BoundryURL);
                    setIsLoading(false);
                }
                else {
                    setState('Invalid');
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });


    }

    function buildMapArea() {
        
        return <div dangerouslySetInnerHTML={{ __html: boundryData }} />
    }


    return (<div>
        <Dialog
            open={true}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {props.Zipcode}
            </DialogTitle>
            <DialogContent>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    {isLoading ?
                        <CircularProgress />
                        :
                        buildMapArea()
                     }
                  
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    </div>
    );








}